export default __webpack_public_path__ + "static/media/token_sOHM-transparent.832b5dd7.png";